import styled from "styled-components";
import { ColorButton } from "../Swatch/SwatchPicker";

const ResourceTableColor = styled(ColorButton)`
  display: flex;
  width: 24px;
  height: 24px;
`

export default ResourceTableColor